export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-volume-strike-c692c798c449a6db021d869d093b427d.svg";